// Type for the Playlist that exists within another Playlist

// Properties for Playlist content that's to be rendered in a tree structure
// defined by the sections

export var typeFilterOptions = [{
  labelTranslationKey: 'state_all',
  value: 'all'
}, {
  labelTranslationKey: 'content_type_playlist_plural',
  value: 'playlists'
}, {
  labelTranslationKey: 'content_type_asset_plural',
  value: 'assets'
}, {
  labelTranslationKey: 'content_type_event_plural',
  value: 'events'
}];
export var statusFilterOptions = [{
  labelTranslationKey: 'state_all',
  value: 'all'
}, {
  labelTranslationKey: 'state_opened',
  value: 'opened'
}, {
  labelTranslationKey: 'state_completed',
  value: 'completed'
}];